import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React from "react";
import { P } from "../../../styles";

const Div = styled.div`
  background: rgba(36, 39, 42, 0.8);
`;
const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 20px;
  padding-top: 20px;

  align-items: center;
`;
const FirstCell = styled.div`
  font-family: "poppins-SemiBold";
`;
const NextCell = styled.div`
  font-family: "poppins-SemiBold";
  padding-bottom: 20px;
  text-align: center;
`;
const SecondCell = styled.div``;

const Socials = styled.div`
  /* font-size:0px; */
  padding-top: 10px;
  display: flex;
  align-items: center;
  @media screen and (max-width: 599px) {
    padding-bottom: 20px;
  }
`;
const Sociallinks = styled.a`
  cursor: pointer;
  margin-left: 10px;

  display: flex;
  align-items: center;
`;
const SocialText = styled.span`
  padding-left: 10px;
  font-weight: 600;
  @media screen and (max-width: 599px) {
    font-size: 11px;
  }
`;
const Text = styled.span`
  font-weight: 600;
  @media screen and (max-width: 599px) {
    text-transform: lowercase;
  }
  @media screen and (max-width: 385px) {
    display: none;
  }
`;

const Cells = styled.div`
  @media screen and (max-width: 599px) {
    display: none;
  }
`;
const Cells1 = styled.div`
  display: none;
  @media screen and (max-width: 599px) {
    display: flex;

    place-content: center;
  }
`;
const SocialImage = styled.img`
  width: 100%;
  height: auto;
  max-width: 30px;
`
const index = () => {
  return (
    <Div>
      <Container maxWidth="xl">
        <Wrapper>
          <Cells>
            <FirstCell>Copyright © 2022 FlokiGold</FirstCell>
          </Cells>

          <SecondCell>
            <Socials>
              <Text>Follow us:</Text>
              <Sociallinks
                href="https://twitter.com/Flokigoldd?t=zbjXk6LWRT4tmeiTyOu00A&s=35"
                target="_blank"
              >
                <SocialImage
                  src="/images/twitter.png"
                />

                <SocialText>Twitter</SocialText>
              </Sociallinks>
              <Sociallinks href="https://t.me/flokigoldeth" target="_blank">
                <SocialImage
                  src="/images/telegram.png" 
                />
                <SocialText>Telegram</SocialText>
              </Sociallinks>
              <Sociallinks
                href="https://medium.com/@riseofcrypto/the-rise-of-floki-gold-2fad5934a8ac"
                target="_blank"
              >
                <SocialImage
                  src="/images/medium.png" 
                />
                <SocialText>Medium</SocialText>
              </Sociallinks>
            </Socials>
          </SecondCell>
        </Wrapper>
        <Cells1>
          <NextCell>Copyright © 2022 FlokiGold</NextCell>
        </Cells1>
      </Container>
    </Div>
  );
};

export default index;
